export type Testimonial = {
  id: string;
  quote: string;
  name: string;
  role: string;
  company: string;
  photo: string;
};

const placeholderQuote =
  'Working with Michael is a pleasure. He is very organized and thorough in his process. He is a great listener and has a knack for enterprise needs. He clearly has a strong grasp of UI that will not only look great but also convert traffic well at the same time. I would highly recommend working with Michael.';

const placeholderPhoto = 'https://cdn.magicpatterns.com/uploads/aD5Yzbkx8viWV47BGRdSgt/1723496860968.jpg';

export const testimonials: Testimonial[] = [
  {
    id: 'testimonial-1',
    quote: placeholderQuote,
    name: 'John Prince',
    role: 'Co-Founder & Co-CEO',
    company: 'HotelPlanner',
    photo: placeholderPhoto,
  },
  {
    id: 'testimonial-2',
    quote:
      'We’ve worked with Mike on a number of projects, both public and internal. He consistently presents thoughtful arguments for his approaches, offers alternative solutions to problems, and adapts to very specific requirements. As a consultancy, BCG has high standards for its own service providers; Mike has met and exceeded them.',
    name: 'Paul Pierson',
    role: 'Branding Expert at Topic Leader',
    company: 'BCG BrightHouse',
    photo: 'https://cdn.magicpatterns.com/uploads/x5sf9dSvSYH8Kwf1kSdZfo/0.jpg',
  },
  {
    id: 'testimonial-3',
    quote:
      'We asked Mike to help with an enterprise architecture project, aligning our technology stack to the true operation of the business. He worked with people across the organization to develop accurate and sharp looking maps of key workflows and processes, bringing high-level visibility to our complex internal systems and enabling leadership to make strategic decisions.',
    name: 'Yuri Mushkin',
    role: 'Chief Risk Officer',
    company: 'OKX (ex-BlockFi)',
    photo: 'https://cdn.magicpatterns.com/uploads/i58WB4G2wNv9FPz69bRzTE/1728961964006.jpg',
  },
];
